<!-- <template>
  <div>
    <v-row dense class="align-center mb-2">
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field
          class="search-field"
          v-model="search"
          prepend-icon="mdi-magnify"
          label="Search..."
          single-line
          solo
          hide-details
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select
          solo
          :items="formattedAccountTypes"
          item-text="display"
          item-value="id"
          append-icon="mdi-chevron-down"
          label="Account Type"
          class="custom-select"
          @change="handleAccountTypeChange"
        ></v-select>
      </v-col>
       <v-col cols="12" sm="6" md="3" lg="3">
          <v-select 
            solo 
            :items="countries" 
            item-text="name"
            item-value="id"
            append-icon="mdi-chevron-down" 
            label="Country"
            class="custom-select"
            @change="handleCountryChange"
          ></v-select>
        </v-col>
      <v-col @click="handleSelectAll" cols="12" sm="6" md="2" lg="2" class="text-right">
        <span class="select">Select all {{ allMasterIB.length }}</span>
      </v-col>
    </v-row>
    <v-row dense class="overflow-account-type">
      <v-col cols="12" v-for="user in filteredUsers" :key="user.id">
        <v-card
          class="mb-2"
          :class="{ 'border-color': user.isChecked }"
          :color="$vuetify.theme.dark ? '#172233' : '#f2f7fb'"
          flat
          tile
        >
          <v-row dense>
            <v-col cols="12">
              <input
                type="checkbox"
                class="custom-checkbox"
                v-model="user.isChecked"
                @change="handleCheckboxChange(user)"
              />
            </v-col>
            <v-col cols="12">
              <v-card-text class="user-information">
                <div class="user-wrapper">
                  <v-avatar size="42">
                    <v-img src="@/assets/user.png"></v-img>
                  </v-avatar>
                  <div class="user-info">
                    <div class="info-details">
                      <span class="title">{{ user.fullname }}</span>
                      <span class="subtitle">(PARENT-{{ user.id }})</span>
                      <div class="d-flex align-center">
                        <div>
                         <v-img width="24" height="16" :src="flagUrl(user?.countries?.iso_code)" :alt="user?.countries?.name"></v-img>
                        </div>
                        <span class="ml-1 subtitle">{{ user?.countries?.name }}</span>
                      </div>
                    </div>
                    <p class="email mb-0">{{ user.email }}</p>
                  </div>
                </div>
                <div class="amount">
                  <span>
                    Business Amount: <strong>${{ user.business_amount }}</strong>
                  </span>
                  <span>Commission: <strong>${{ user.ib_commission }}</strong></span>
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12">
              <ul class="chips">
                <li 
                  v-for="type in user.tradingAccountTypes" 
                  :key="type.id"
                  class="account-type-chip"
                >
                  {{ type.account_type_display }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ASSIGNACCTYPE__ACTIONS } from "@/store/action-types";

export default {
  name: 'IbAssign',
  props: {
    allMasterIB: {
      type: Array,
      required: true,
      default: () => []
    },
    allAccountTypes: {
      type: Array,
      required: true,
      default: () => []
    },
      countries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: ""
    };
  },
  computed: {
     
    formattedAccountTypes() {
      return this.allAccountTypes.map(type => ({
        id: type.id,
        display: `${type.account_type_display} (${type.LiveDemo}) - ${type.Mt4Mt5}`
      }));
    },
    filteredUsers() {
      if (!this.search) return this.allMasterIB;

      const searchTerm = this.search.toLowerCase();
      return this.allMasterIB.filter(user => 
        user.fullname.toLowerCase().includes(searchTerm) ||
        user.email.toLowerCase().includes(searchTerm) ||
        user.id.toString().includes(searchTerm)
      );
    }
  },
  methods: {
    ...mapActions("assignacctype", [
      ASSIGNACCTYPE__ACTIONS.ALLMASTERIB
    ]),
     flagUrl(iso_code) {
      if (!iso_code) return '';
      return `https://flagsapi.com/${iso_code}/flat/64.png`;
    },
    handleAccountTypeChange(value) {
     this[ASSIGNACCTYPE__ACTIONS.ALLMASTERIB]({
       account_type:value
     })
    },
    handleCountryChange(value) {
      this[ASSIGNACCTYPE__ACTIONS.ALLMASTERIB]({
       country:value
     })
    },
    handleCheckboxChange(user) {
      const isAnyOptionChecked = this.allMasterIB.some(item => item.isChecked);
      const allSelectedPartners = this.allMasterIB.filter(item => item.isChecked);
      this.$emit('updateCheckboxStatus', isAnyOptionChecked);
      this.$emit('updateSelectedPartners', allSelectedPartners);
    },
    handleSelectAll() {
     this.allMasterIB.forEach((user, index) => {
      this.$set(this.allMasterIB[index], 'isChecked', true);
    });
      this.$emit('updateCheckboxStatus', true);
      this.$emit('updateSelectedPartners', this.allMasterIB);
    },
  }
};
</script> -->

<template>
  <div>
    <v-row dense class="align-center mb-2">
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-text-field v-model="search" @input="debounceSearch" class="search-field" prepend-icon="mdi-magnify"
          label="Search..." single-line solo hide-details>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select solo :items="formattedAccountTypes" item-text="display" item-value="id" append-icon="mdi-chevron-down"
          label="Account Type" class="custom-select" v-model="selectedAccountType"
          @change="handleAccountTypeChange"></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select solo :items="countries" item-text="name" item-value="id" append-icon="mdi-chevron-down"
          label="Country" class="custom-select" v-model="selectedCountry" @change="handleCountryChange"></v-select>
      </v-col>
      <v-col v-if="$canRoute('assign-account-type') === 1" @click="handleSelectAll" cols="12" sm="6" md="2" lg="2" class="text-right">
        <span class="select">Select all {{ allMasterIB.length }}</span>
      </v-col>
    </v-row>

     <div v-if="isLoading" class="text-center py-5">
      <v-progress-circular indeterminate color="secondary"></v-progress-circular>
    </div>
    
    <v-row v-else dense class="overflow-account-type">
      <v-col cols="12" v-for="user in allMasterIB" :key="user.id">
        <v-card class="mb-2" :class="{ 'border-color': user.isChecked }"
          :color="$vuetify.theme.dark ? '#172233' : '#f2f7fb'" flat tile>
          <v-row dense>
            <v-col cols="12">
              <input v-if="$canRoute('assign-account-type') === 1" type="checkbox" class="custom-checkbox" v-model="user.isChecked"
                @change="handleCheckboxChange(user)" />
            </v-col>
            <v-col cols="12">
              <v-card-text class="user-information">
                <div class="user-wrapper">
                  <v-avatar size="42">
                    <v-img
                      :src="`https://ui-avatars.com/api/?name=${user?.fullname}&background=random` || require('@/assets/user.png')"></v-img>
                  </v-avatar>
                  <div class="user-info">
                    <div class="info-details">
                      <span class="title">{{ user?.fullname }}</span>
                      <span class="subtitle">(PARENT-{{ user?.id }})</span>
                      <div class="d-flex align-center">
                        <div>
                          <v-img width="24" height="16" :src="flagUrl(user?.countries?.iso_code)"
                            :alt="user?.countries?.name"></v-img>
                        </div>
                        <span class="ml-1 subtitle">{{ user?.countries?.name }}</span>
                      </div>
                    </div>
                    <p class="email mb-0">{{ user?.email }}</p>
                  </div>
                </div>
                <div class="amount">
                  <span>
                    Business Amount: <strong>${{ user?.business_amount }}</strong>
                  </span>
                  <span>Commission: <strong>${{ user?.ib_commission }}</strong></span>
                </div>
              </v-card-text>
            </v-col>
            <v-col cols="12">
              <ul class="chips">
                <li v-for="type in user?.tradingAccountTypes" :key="type.id" class="account-type-chip">
                  {{ type?.account_type_display }}
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <!-- Pagination -->
    <v-row v-if="!isLoading && allMasterIB.length > 0">
      <v-col cols="12">
        <v-pagination v-model="currentPage" :length="pagination.lastPage" :total-visible="7"
          @input="handlePageChange"></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ASSIGNACCTYPE__ACTIONS } from "@/store/action-types";

export default {
  name: 'IbAssign',
  props: {
    countries: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      search: "",
      searchTimeout: null,
      selectedAccountType: null,
      selectedCountry: null,
      currentPage: 1
    };
  },
  computed: {
    ...mapState("assignacctype", ['allMasterIB', 'allAccountTypes', 'pagination', 'isLoading']),
    formattedAccountTypes() {
      return [
        { id: 'All', display: 'All Account Types' },
        ...this.allAccountTypes.map(type => ({
          id: type.id,
          display: `${type.account_type_display} (${type.LiveDemo}) - ${type.Mt4Mt5}`
        }))
      ];
    }
  },
  methods: {
    ...mapActions("assignacctype", [
      ASSIGNACCTYPE__ACTIONS.ALLMASTERIB
    ]),

    flagUrl(iso_code) {
      if (!iso_code) return '';
      return `https://flagsapi.com/${iso_code}/flat/64.png`;
    },

    handleAccountTypeChange(value) {
      this.currentPage = 1;
      this.fetchData();
    },

    handleCountryChange(value) {
      this.currentPage = 1;
      this.fetchData();
    },

    handlePageChange(page) {
      this.fetchData();
    },

    handleCheckboxChange(user) {
      const isAnyOptionChecked = this.allMasterIB.some(item => item.isChecked);
      const allSelectedPartners = this.allMasterIB.filter(item => item.isChecked);
      this.$emit('updateCheckboxStatus', isAnyOptionChecked);
      this.$emit('updateSelectedPartners', allSelectedPartners);
    },

    handleSelectAll() {
      this.allMasterIB.forEach((user, index) => {
        this.$set(this.allMasterIB[index], 'isChecked', true);
      });
      this.$emit('updateCheckboxStatus', true);
      this.$emit('updateSelectedPartners', this.allMasterIB);
    },

    async fetchData() {
      const parameter = {
        page: this.currentPage,
        limit: 10,
        search: this.search || undefined,
        account_type: this.selectedAccountType !== 'All' ? this.selectedAccountType : undefined,
        country: this.selectedCountry !== 'All' ? this.selectedCountry : undefined
      };

      await this[ASSIGNACCTYPE__ACTIONS.ALLMASTERIB](parameter);
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1; // Reset to first page on search
        this.fetchData();
      }, 500);
    }
  },
  watch: {
    pagination: {
      handler(newVal) {
        // Ensure currentPage is in sync with pagination from API
        if (newVal && this.currentPage !== newVal.currentPage) {
          this.currentPage = newVal.currentPage;
        }
      },
      deep: true
    }
  },
  async created() {
    // Set initial values
    this.selectedAccountType = 'All';
    this.selectedCountry = 'All';
    await this.fetchData();
  }
};
</script>